import dynamic from 'next/dynamic';

import { Author } from '@natu/ui/Author';
import { cn } from '@natu/utils/cn';

import { type StoryblokRichTextData } from '../../../richtext';
import {
  type Elevation,
  type SBProps,
  type StoryblokAsset,
  type StoryblokPalette,
  getAssetFromStoryblok,
  resolveStoryblokStyles,
  sbEditable,
} from '../../../utils';

const StoryblokRichtext = dynamic(() =>
  import('../../../richtext').then(mod => mod.StoryblokRichtext),
);

interface SBCardTestimonialProps {
  image?: StoryblokAsset;
  name?: string;
  role?: string;
  testimonial?: StoryblokRichTextData;
  elevationMobile?: Elevation;
  elevationTablet?: Elevation;
  elevationDesktop?: Elevation;
  bgColor?: StoryblokPalette;
}

export const SBCardTestimonial = ({ blok }: SBProps<SBCardTestimonialProps>) => {
  const {
    image,
    name,
    role,
    testimonial,
    elevationMobile,
    elevationTablet,
    elevationDesktop,
    bgColor,
  } = blok;

  const imageProps = getAssetFromStoryblok(image, { type: 'image' });

  const className = resolveStoryblokStyles({
    elevation: elevationMobile,
    elevationTablet,
    elevationDesktop,
    className: bgColor?.value ? 'bg-[var(--bg-sb-color)]' : 'bg-gray-50',
  });

  const style = bgColor?.value ? { '--bg-sb-color': bgColor.value } : undefined;

  return (
    <div style={style} className={cn(className, 'rounded-xl p-6 pb-8')} {...sbEditable(blok)}>
      <Author className="mb-6" image={imageProps} name={name} role={role} />
      {testimonial && (
        <StoryblokRichtext
          className="text-lg text-gray-600 md:text-sm md:leading-[22px]"
          data={testimonial}
        />
      )}
    </div>
  );
};
